import { render } from "./ErrorMessage.vue?vue&type=template&id=0a0dfdd8&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"

import "./ErrorMessage.vue?vue&type=style&index=0&id=0a0dfdd8&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0dfdd8"]])

export default __exports__